export function skipLogicCore(): string {
  return 'skip-logic-core';
}

export interface SkipLogicQuestionSettings {
  id: string;
  page_id: number;
  element_id: number;
}

export interface SkipLogicQuestionConfig {
  id: string;
  page_id: number;
  element_id: number;
}

//
export const QUESTION_TYPE_CONFIG: Record<
  string,
  { label: string; operators: string[] }
> = {
  // Choice Types
  'single-choice': {
    label: 'Single Choice',
    operators: ['is', 'is_not', 'inc_any', 'not_inc_any', 'ans', 'nans'],
  },
  'multiple-choice': {
    label: 'Multiple Choice',
    operators: ['is_any_of', 'is_not_any_of', 'inc_all', 'is_ex', 'is_not_ex','count_eq', 'count_gt', 'count_gte', 'count_lt', 'count_lte', 'ans', 'nans'],
  },
  'drop-down-single-choice': {
    label: 'Drop Down Single Choice',
    operators: ['is', 'is_not', 'inc_any', 'not_inc_any', 'ans', 'nans'],
  },
  'drop-down-multiple-choice': {
    label: 'Drop Down Multiple Choice',
    operators: ['is_any_of', 'is_not_any_of', 'inc_all', 'is_ex', 'is_not_ex','count_eq', 'count_gt', 'count_gte', 'count_lt', 'count_lte', 'ans', 'nans'],
  },

  // Text Types
  'open-ended': {
    label: 'Open Ended',
    operators: ['eq_text', 'neq_text', 'cont', 'not_cont', 'sw', 'ew', 'ans', 'nans'],
  },
  numeric: {
    label: 'Numeric',
    operators: ['eq_num', 'neq_num', 'gt', 'gte', 'lt', 'lte', 'bet_num', 'not_bet_num', 'ans', 'nans'],
  },

  // Media Types
  image: {
    label: 'Image',
    operators: ['ans', 'nans'],
  },
  video: {
    label: 'Video',
    operators: ['ans', 'nans'],
  },
  voice: {
    label: 'Voice',
    operators: ['ans', 'nans'],
  },
  file: {
    label: 'File',
    operators: ['ans', 'nans'],
  },

  // Matrix Types
  'single-grid': {
    label: 'Single Grid',
    operators: [
      'row_is',
      'row_is_not',
      'ans',
      'nans',
    ],
  },

  'multiple-grid': {
    label: 'Multiple Grid',
    operators: [
      'row_inc_any',
      'row_not_inc_any',
      'row_inc_all',
      'row_is_ex',
      'row_is_not_ex',
      'row_count_eq',
      'row_count_gt',
      'row_count_gte',
      'row_count_lt',
      'row_count_lte',
      'ans',
      'nans',
    ],
  },

  // Ordering
  'click-to-rank': {
    label: 'Click to Rank',
    operators: ['rank_is', 'rank_not_is', 'rank_gt', 'rank_gte', 'rank_lt', 'rank_lte', 'rank_bet', 'rank_not_bet', 'ans', 'nans'],
  },

  // Skip Logic (for reference)
  'skip-logic': {
    label: 'Skip Logic',
    operators: [],
  },
};
